import { render, staticRenderFns } from "./AppendiceInclusioneForm.vue?vue&type=template&id=59f8e8f7&scoped=true"
import script from "./AppendiceInclusioneForm.vue?vue&type=script&lang=js"
export * from "./AppendiceInclusioneForm.vue?vue&type=script&lang=js"
import style0 from "./AppendiceInclusioneForm.vue?vue&type=style&index=0&id=59f8e8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f8e8f7",
  null
  
)

export default component.exports